import React, { Component } from 'react';
import { Modal, Button, Table, Form, Input, Divider, message, Select, DatePicker, Spin, Tooltip  } from 'antd';
import axios from '../../service/index'
const { Option } = Select;
const { RangePicker } = DatePicker;
// const { TabPane } = Tabs;
class Statistics extends Component {

	constructor(props) {
		super(props)
		this.state = {
      loading: false,
			dateValue: [],
			visible: false,
			searchName: '',
			endTime: '',
			startTime: '',
			subjectId: "",
			autoSyn: 0,
			total: 0,
			searchData: {
				pageNum: 1,
				pageSize: 10,
			},
			isTeacher: 2,
			labelName: '',
			allowClear: false,
			labelId: null,
			modelTitle: '新建标签',

			subjectList: [],
			btnColor: true,
			btnType: 1,
			type: '',
			btnList: [
				{
					id: 1,
					name: '课程视频',
					columns: [
						{
							title: '课程名称',
							dataIndex: 'name',
							key: 'name',
							ellipsis: true,
							render: (text, record) => (
								<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
							)
						},
						{
							title: '所属学科',
							dataIndex: 'subjectName',
							key: 'subjectName',
							align: 'center'
						},
						{
							title: '所属阶段',
							dataIndex: 'stageName',
							key: 'stageName',
							align: 'center'
						},
						{
							title: '收藏人数',
							dataIndex: 'collectCount',
							key: 'collectCount',
							align: 'center'
						},
						{
							title: '转发人数',
							dataIndex: 'forwardPopCount',
							key: 'forwardPopCount',
							align: 'center'
						},
						{
							title: '转发次数',
							dataIndex: 'forwardClickCount',
							key: 'forwardClickCount',
							align: 'center'
						},
						{
							title: '播放人数',
							dataIndex: 'playCount',
							key: 'playCount',
							align: 'center'
						},
					]
				},
				{
					id: 2,
					name: '面试题目',
					columns: [
						{
							title: '题干',
							dataIndex: 'name',
							key: 'name',
							ellipsis: true,
							render: (text, record) => (
								<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
							)
						},
						{
							title: '所属学科',
							dataIndex: 'subjectName',
							key: 'subjectName',
							align: 'center'
						},
						{
							title: '所属知识点',
							dataIndex: 'konwledgeName',
							key: 'konwledgeName',
							align: 'center'
						},
						{
							title: '收藏人数',
							dataIndex: 'collectCount',
							key: 'collectCount',
							align: 'center'
						},
						{
							title: '打开人数',
							dataIndex: 'clickCount',
							key: 'clickCount',
							align: 'center'
						},
						{
							title: '打开次数',
							dataIndex: 'openCount',
							key: 'openCount',
							align: 'center'
						}
					]
				},
				{
					id: 3,
					name: '课程资料',
					columns: [
						{
							title: '资料包名称',
							dataIndex: 'name',
							key: 'name',
						},
						{
							title: '所属学科',
							dataIndex: 'subjectName',
							key: 'subjectName',
							align: 'center'
						},
						{
							title: '打开人数',
							dataIndex: 'openCount',
							key: 'openCount',
							align: 'center'
						},
						{
							title: '获取人数',
							dataIndex: 'obtainCount',
							key: 'obtainCount;',
							align: 'center'
						}
					]
				},
				{
					id: 4,
					name: 'banner',
					columns: [
						{
							title: '轮播图名称',
							dataIndex: 'name',
							key: 'name',
							ellipsis: true,
							render: (text, record) => (
								<Tooltip placement="topLeft" title={text}>{text}</Tooltip>
							)
						},
						{
							title: '点击人数',
							dataIndex: 'clickCount',
							key: 'clickCount',
							align: 'center'
						},
						{
							title: '点击次数',
							dataIndex: 'openCount',
							key: 'openCount',
							align: 'center'
						}
					]
				},
				{
					id: 5,
					name: '广告位',
					columns: [
						{
							title: '广告名称',
							dataIndex: 'name',
							key: 'name',
							align: 'center'
						},
						{
							title: '点击人数',
							dataIndex: 'clickCount',
							key: 'clickCount',
							align: 'center'
							
						},
						{
							title: '点击次数',
							dataIndex: 'openCount',
							key: 'openCount',
							align: 'center'
						}
					]
				},
				{
					id: 6,
					name: '直播课',
					columns: [
						{
							title: '轮播图名称',
							dataIndex: 'name',
							key: 'name',
							align: 'center'
						},
						{
							title: '所属学科',
							dataIndex: 'subjectName',
							key: 'subjectName',
							align: 'center'
						},
						{
							title: '点击人数',
							dataIndex: 'clickCount',
							key: 'clickCount',
							align: 'center'
						},
						{
							title: '点击次数',
							dataIndex: 'openCount',
							key: 'openCount',
							align: 'center'
						}
					]
				},
				{
					id: 7,
					name: '免费资源',
					columns: [
						{
							title: '资源名称',
							dataIndex: 'name',
							key: 'name',
							align: 'center'
						},
						{
							title: '所属学科',
							dataIndex: 'subjectName',
							key: 'subjectName',
							align: 'center'
						},
						{
							title: '点击人数',
							dataIndex: 'clickCount',
							key: 'clickCount',
							align: 'center'
						},
						{
							title: '获取人数',
							dataIndex: 'openCount',
							key: 'openCount',
							align: 'center'
						}
					]
				},
				{
					id: 8,
					name: '直播统计',
					columns: [
						{
							title: '直播主题',
							dataIndex: 'liveTheme',
							key: 'liveTheme',
							align: 'center'
						},
						{
							title: '直播时间',
							dataIndex: 'liveTime',
							key: 'liveTime',
							align: 'center'
						},
						{
							title: '观看人数',
							dataIndex: 'viewersPersonNum',
							key: 'viewersPersonNum',
							align: 'center'
						},
						{
							title: '观看次数',
							dataIndex: 'viewersNum',
							key: 'viewersNum',
							align: 'center'
						},
						{
							title: '操作',
							align: 'center',
							render: (row) => {
								return (
									<div className="operate">
										<Button type="link" onClick={() => { this.goDetail(row) }
											}>观看详情</Button>
									</div>
								)
							}
							
						}
					]
				}
			],
			defaultCurrent: 1,
		}
	}
	componentDidMount() {
		this.getSubjectList()
		let type = this.props.location.state && this.props.location.state.type? this.props.location.state.type : 1;
		console.log(this.props.location.state, 'typeleixing ');
		this.setState({btnType: type},() => {
      this.getTableList()
    })
		console.log(this.props.location, '请求数据')
	}
	componentWillUnmount() {
		this.setState = () => false;
		this.setState({btnType: 1},() => {
     
    })
	}
	showModal = (e) => {
		this.setState({
			modelTitle: '新增标签',
			visible: true
		})

	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			console.log(err, values)
			if (!err) {
				if (this.state.modelTitle === '新增标签') {
					axios.post('labelController/add', {
						name: values.name
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				} else {
					axios.post('labelController/update', {
						name: values.name,
						id: this.state.labelId
					}).then(res => {
						console.log(res)
						if (res.data.code === '200') {
							message.success('编辑成功')
							this.lableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
				}

			}
		})
	}
	goDetail(row) {
		console.log(row, '参数');
		this.props.history.push('/wxChannelsDetail',{id: row.id,name: row.liveTheme,type: this.state.btnType})
	}
	getTableList = () => {
    this.setState({
      loading: true
    })

		if (this.state.btnType === 8) {
			axios.post('wxChannels/statistics', {
				...this.state.searchData,
				name: this.state.searchName,
				startLiveTime: this.state.startTime,
				endLiveTime: this.state.endTime,
			}).then(res => {
				this.setState({
					tableList: []
				})
				if (res.data.code === '200') {
					this.setState({
						tableList: res.data.data.records,
						total: res.data.data.total,
						loading: false
					})
				}
			})
		} else {
			window.history.replaceState(null, '')
			
			axios.post('buriedPointController/buriedPoint', {
				...this.state.searchData,
				type: this.state.btnType,
				name: this.state.searchName,
				startTime: this.state.startTime,
				endTime: this.state.endTime,
				subjectId: this.state.subjectId
			}).then(res => {
				this.setState({
					tableList: []
				})
				if (res.data.code === '200') {
					this.setState({
						tableList: res.data.data.list,
						total: res.data.data.total,
						loading: false
					})
				}
			})
		}
		
	}
	getSubjectList = () => {
		axios.post('subjectController/getSubject', {
			pageNum: 1,
			pageSize: 1000
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					subjectList: res.data.data.list
				})
			}
		})
	}
	delLable(id) {
		axios.get(`labelController/del/${id}`).then(res => {
			if (res.data.code === '200') {
				message.success('删除成功')
				this.lableList()
			} else {
				message.error(res.data.msg)
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false
		})
	};
	exportData() {
		if (this.state.btnType === 8) { // 直播统计
			axios.get(`/wxChannels/exportLiveGet?endLiveTime=${this.state.endTime}&
			startLiveTime=${this.state.startTime}&liveTheme=${this.state.searchName}`, { responseType: 'blob' }).then(res => {
				const link = document.createElement('a')
				let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
				link.style.display = 'none'
				link.href = URL.createObjectURL(blob)
				link.setAttribute('download', '直播统计.xlsx')
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			})
		}else {
			axios.get(`/buriedPointController/buriedPointExp?
			endTime=${this.state.endTime}&
			startTime=${this.state.startTime}&
			type=${this.state.btnType}&
			name=${this.state.searchName}&
			subjectId=${this.state.subjectId === undefined || this.state.btnType === 5 || this.state.btnType === 4 ?  '' : this.state.subjectId}`, { responseType: 'blob' }).then(res => {
				const link = document.createElement('a')
				let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
				link.style.display = 'none'
				link.href = URL.createObjectURL(blob)
				link.setAttribute('download', this.state.btnList[this.state.btnType - 1].name + '统计.xlsx')
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			})
		}
	}

	render() {
		const { loading, tableList, modelTitle, visible, labelName, total, btnList, btnType, subjectList, dateValue } = this.state
		const { getFieldDecorator } = this.props.form;
		const pagination = {
			showSizeChanger: true,
			total: total,
			current: this.state.searchData.pageNum,
			defaultCurrent: this.state.defaultCurrent,
			pageSizeOptions: ['10', '20', '30', '40'],
			showTotal: () => `共 ${total} 条`,
			onShowSizeChange: (current, pageSize) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				searchData.pageSize = pageSize
				this.getTableList(searchData)
			},
			onChange: (current) => {
				let searchData = this.state.searchData
				searchData.pageNum = current
				this.getTableList(searchData)
			},
		}
		return (
			<div className="userlist">
				<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>资源数据统计</span>
				<Divider />
        <Spin spinning={loading}> 
          {
            btnList.map(item => {
              return (<Button
                key={item.id}
                style={{ marginRight: '20px', marginBottom: '20px' }}
                type={item.id === btnType ? 'primary' : 'default'}
                onClick={() => {
                  this.setState({
                    btnType: item.id,
                    defaultCurrent: 1,
                    dateValue: [null, null],
                    searchName: '',
                    subjectId: '',
                    searchData: {
                      pageNum: 1,
                      pageSize: 10,
                    },
                  },()=> {
                    this.getTableList()
                  })
                }}
              >{item.name}</Button>)
            })
          }
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {<Input allowClear value={this.state.searchName} style={{ width: '160px', height: '40px', marginRight: '20px', marginBottom: '20px' }}
                placeholder="关键字搜索"
                onChange={(e) => {
                  this.setState({
                    searchName: e.target.value
                  })
                }}
              ></Input>}
              {btnType === 4 || btnType === 5 || btnType === 8? '' : <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <span>学科：</span>
                <Select placeholder="请选择学科" value={this.state.subjectId} style={{ width: 200, height: '40px' }} onChange={(value) => {
                  this.setState({
                    subjectId: value,
                  })
                }}>
                  <Option value={""}>全部</Option>
                  {
                    subjectList.map(item => {
                      return <Option key={item.id} value={item.id}>{item.name}</Option>
                    })
                  }
                </Select>
              </div>}
              <RangePicker value={dateValue} onChange={(date, dateString) => {
                console.log(date, dateString);
                this.setState({
                  startTime: dateString[0],
                  endTime: dateString[1],
                  dateValue: date

                })
              }} />
              <Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
                  this.setState({
                    defaultCurrent: 1,
                    searchData: {
                      pageSize: 10,
                      pageNum: 1,
                    },
                  }, () => {
                    this.getTableList()
                  })
              }}>搜索</Button>
              <span className='my-button-txt' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
                this.setState({
                  subjectId: '',
                  btnType: this.state.btnType,
                  dateValue: [null,null],
                  searchName: '',
                  startTime: '',
                  endTime: '',
                  defaultCurrent: 1,
                  searchData: {
                    pageSize: 10,
                    pageNum: 1,
                  },
                }, () => {
                  this.getTableList()
                })
              }}>重置</span>
            </div>
            <div>
            {<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
                this.exportData()
              }}>导出</Button>}
            </div>
          </div>
          {
            <Table
              pagination={pagination}
              dataSource={tableList}
              columns={btnList[btnType - 1].columns}
              rowKey={record => record.mysqlId} rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
            />
          }
        </Spin>
				<Modal
					getContainer={true}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 12 }} onSubmit={this.handleOk}>
						<Form.Item label={"标签名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入标签名称!', }],
								initialValue: modelTitle === '编辑标签' ? labelName : ''
							})(
								<Input placeholder='请输入标签名称' />
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}

};

export default Form.create()(Statistics)